module.exports = __webpack_public_path__ + "img/twitter-icon.d555b899.svg";